import * as Yup from "yup";

import {numberTypeMessage} from "./messages";

export default function (){

    const currencyTransform = function(value, originalValue){
        if (typeof originalValue === 'string' && originalValue === '') {
            return null;
        }

        if(originalValue === undefined || originalValue === null ) {
            return null;
        }

        if(typeof originalValue === 'number') {
            return originalValue;
        }

        return Number(originalValue.replace(/,/g, ''));
    }

    return Yup.number()
        .nullable()
        .min(0)
        .integer()
        .typeError(numberTypeMessage)
        .transform(currencyTransform);

}
